// extracted by mini-css-extract-plugin
export default {"list":"CatalogBlock_list__4rvcP","item":"CatalogBlock_item__vgEu0"};